var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.height)?_c('input-with-unit',{attrs:{"alternative-units":['px', 'vh', '%'],"size":"small"},on:{"updated":_vm.set},model:{value:(_vm.height),callback:function ($$v) {_vm.height=$$v},expression:"height"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }